const defaultState = {
    currentUser: null,
}

const SET_CURRENT_USER = "SET_CURRENT_USER"
const GET_CURRENT_USER = "GET_CURRENT_USER"

export const currentUserReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CURRENT_USER:
            return {...state, currentUser: {...state.currentUser, ...action.payload}}

        case GET_CURRENT_USER:
            return state.currentUser

        default:
            return state
    }
}

export const setCurrentUserAction = (payload) => ({type: SET_CURRENT_USER, payload})
export const getCurrentUserAction = () => ({type: GET_CURRENT_USER})
